export const BUS_QUICK_ADD_TOGGLE = 'layout-new-toggle'